import React, { useState } from "react";
import Slider from "react-slick";
import SectionTitle2 from "../../elements/section-title2/SectionTitle2";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const certificateData = [
  {
    id: 3,
    image: "/images/certificate/certificate-03.webp",
  },
  {
    id: 4,
    image: "/images/certificate/certificate-04.webp",
  },
  {
    id: 5,
    image: "/images/certificate/certificate-05.webp",
  },
  {
    id: 6,
    image: "/images/certificate/certificate-06.webp",
  },
  {
    id: 7,
    image: "/images/certificate/certificate-07.webp",
  },
];

const Certificate = () => {
  const [sliderRef, setSliderRef] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="section section-padding-equal">
      <div className="container">
        <div className="background">
          <div className="title-padding">
            <SectionTitle2
              title="Accreditations"
              description="Accreditations Certified under ISO 9001, ISO 14001, and OHSAS 18001 by a UAF-accredited body.."
              textAlignment=""
              textColor=""
            />
          </div>
          <div className="certificate-slider-container">
            <div className="slider-navigation2">
              <button className="certificate-prev-arrow" onClick={() => sliderRef?.slickPrev()}>
                ←
              </button>
              <button className="certificate-next-arrow" onClick={() => sliderRef?.slickNext()}>
                →
              </button>
            </div>
            <Slider ref={setSliderRef} {...settings}>
              {certificateData.map((certificate) => (
                <div key={certificate.id} className="certificate-slide">
                  <div className="certificate-card">
                    <div className="certificate-image">
                      <img src={certificate.image} alt={certificate.title} />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;